export default __webpack_public_path__ + "static/media/flag_ru.c789ea20.svg";